import {popperGenerator} from './index.js';
import eventListeners from './modifiers/eventListeners.js';
import popperOffsets from './modifiers/popperOffsets.js';
import computeStyles from './modifiers/computeStyles.js';
import applyStyles from './modifiers/applyStyles.js';
import detectOverflow from './utils/detectOverflow.js';

var defaultModifiers = [eventListeners, popperOffsets, computeStyles, applyStyles];
var createPopper = /*#__PURE__*/ popperGenerator({
  defaultModifiers: defaultModifiers,
}); // eslint-disable-next-line import/no-unused-modules

export {createPopper, popperGenerator, defaultModifiers, detectOverflow};
import {placements} from './enums';
import FLIP from './modifiers/flip';
import PREVENT_OVERFLOW from './modifiers/preventOverflow';
import ARROW from './modifiers/arrow';

export {placements as Placement, FLIP, PREVENT_OVERFLOW, ARROW};
